module.exports = __webpack_public_path__ + "static/assets/be452584e460faabf320c194528acf60.svg";